// Static detailed site content (long bullet lists, pillars, steps, equipment).
export const PILLARS = [
  { title: "WE UNDERSTAND NEW AUTHORITIES", text: "Everybody wants established carriers. We aren't afraid to work with the company that's just getting started." },
  { title: "WE TEACH — WE DON'T GATEKEEP", text: "We want our clients to understand their business, not remain dependent on someone forever." },
  { title: "WE'RE TRANSPARENT", text: "If something isn't working, we're going to tell you." },
  { title: "WE LOOK BEYOND THE LOAD", text: "Dispatch is important. Compliance, HR, driver management, documentation, revenue, and safety matter too." },
  { title: "WE BUILD RELATIONSHIPS", text: "You're not treated like another MC number." },
];

export const VALUES = ["FAITH", "INTEGRITY", "STRUCTURE", "GROWTH"];
export const JOURNEY = ["START", "STRUCTURE", "DISPATCH", "COMPLY", "GROW"];

export const STEPS = [
  { num: "01", title: "CHOOSE YOUR SERVICE", text: "Pick the support your trucking business needs right now." },
  { num: "02", title: "TELL US ABOUT YOUR BUSINESS", text: "Share where you are today and where you're trying to go." },
  { num: "03", title: "WE BUILD YOUR PLAN", text: "We map out the structure, systems, and next steps." },
  { num: "04", title: "LET'S MOVE FORWARD", text: "We get to work and keep you moving — every mile." },
];

export const EQUIPMENT = [
  { name: "26-ft Box Trucks", key: "boxTruck" },
  { name: "Flatbeds", key: "flatbed" },
  { name: "Semi Trucks", key: "blueSkySemi" },
  { name: "18-Wheelers", key: "redSemi" },
];

export const DISPATCH_SERVICES = [
  "Searching for loads", "Load board management", "Broker communication", "Rate negotiation",
  "Carrier packet assistance", "Rate confirmation review", "Pickup and delivery coordination",
  "Driver communication", "Route planning assistance", "Load tracking", "BOL follow-up",
  "Broker relationship building", "Factoring coordination when needed", "Weekly revenue tracking",
  "Assistance planning the next load/reload",
];

export const HR_SERVICES = [
  "Driver onboarding", "Driver files and document organization", "Driver agreements", "Company policies",
  "Employee/contractor paperwork", "Driver qualification document tracking", "Expiration-date tracking",
  "Compliance reminders", "Revenue reports", "Weekly/monthly operational reports",
  "Driver performance documentation", "Incident documentation", "BOL organization",
  "Fuel receipt organization", "Safety documentation", "Internal forms and checklists",
  "Recordkeeping assistance", "Safety audit preparation", "Administrative support",
];

export const HR_PRICING = [
  { tier: "1 DRIVER", price: "$200", unit: "/month" },
  { tier: "2–5 DRIVERS", price: "$300", unit: "/month" },
  { tier: "LARGER FLEETS", price: "Custom", unit: "Pricing" },
];

export const HR_STARTUP_INCLUDES = [
  "Driver/Employee Interviewing", "New-Hire Training", "Customized Employee Handbook",
  "ADP Employee Setup", "Direct Deposit Setup", "Paystub Setup & Processing Support",
  "MVR Background Check", "Criminal Background Check", "Employee Training Packets",
  "New-Hire Onboarding Documents", "Human Resources Setup & Support",
];

export const COMPLIANCE_CATEGORIES = ["DRIVER FILES", "DOCUMENTS", "EXPIRATIONS", "REVENUE", "SAFETY", "AUDIT READINESS"];

export const STARTUP_INCLUDES = [
  "LLC setup assistance", "EIN setup", "FMCSA registration/application assistance",
  "USDOT/MC authority setup assistance when applicable", "BOC-3 setup", "UCR registration",
  "Required filing guidance", "Factoring company setup assistance", "Business structure guidance",
  "Dispatch preparation", "Compliance setup", "New authority coaching", "Business startup checklist",
  "Personalized guidance throughout the process",
];

export const TRAINING_WEEKS = [
  { week: "WEEK 1", title: "Foundations + Freight Operations" },
  { week: "WEEK 2", title: "Real-World Dispatching + Business Development" },
];

export const TRAINING_INCLUDES = [
  "2 weeks of live Zoom training", "Hands-on dispatch training", "How to use load boards",
  "Searching and booking freight", "Rate negotiation", "Understanding RPM — Rate Per Mile",
  "Broker communication", "Carrier packets", "Rate confirmations", "BOL paperwork", "Route planning",
  "Understanding box truck, flatbed, and semi freight", "Building relationships with brokers and carriers",
  "Starting and structuring a freight/logistics business", "Business guidance and coaching",
  "Final assessment", "Certificate of Completion",
];

export const AUDIT_INCLUDES = [
  "Review of company records", "Driver documentation review", "Driver qualification file organization",
  "Hours-of-service documentation review", "Vehicle records review", "Maintenance documentation review",
  "Accident/incident documentation review", "Insurance and company document review",
  "Drug & alcohol compliance documentation review when applicable", "Document checklist",
  "Missing-document identification", "Audit preparation guidance", "Organization of records for submission",
  "Follow-up assistance during preparation",
];

export const MENTORSHIP_MODULES = [
  { title: "Business Formation & Authority Setup", items: ["Trucking company formation guidance", "USDOT and MC authority application assistance", "BOC-3 and UCR registration guidance", "Business structure and operational planning", "Insurance and factoring company guidance"] },
  { title: "Fleet Management & Operations", items: ["Truck acquisition and equipment planning", "CDL and non-CDL operational strategies", "Driver recruitment and onboarding", "Fleet manager responsibilities and workflows", "Daily trucking operations and dispatch coordination"] },
  { title: "DOT Compliance & Safety", items: ["FMCSA compliance education", "New Entrant Safety Audit preparation", "Driver Qualification Files (DQF)", "Hours of Service and ELD training", "Drug and alcohol program requirements", "Safety policies and recordkeeping systems"] },
  { title: "Dispatching & Revenue Development", items: ["Load board navigation and freight sourcing", "Broker communication and rate negotiation", "Rate-per-mile and profitability calculations", "Lane planning and load management", "Dispatch procedures and carrier relationships"] },
  { title: "Financial & Business Growth Strategies", items: ["Operating expense and cash-flow planning", "Driver compensation structures", "Revenue tracking and profit analysis", "Business growth and fleet expansion planning", "Building sustainable operational systems"] },
];

export const SERVICE_OPTIONS = [
  "Dispatch Services", "HR & Back Office", "HR Start-Up Package", "Trucking Company Startup", "Elite Trucking Business Mentorship", "Dispatch Training",
  "Safety Audit Preparation", "Extended Compliance Reconstruction", "Other",
];

export const EQUIPMENT_OPTIONS = ["Box Truck", "Flatbed", "Semi Truck", "18-Wheeler", "Mixed Fleet", "Other"];

export const LEAD_STATUSES = ["new", "contacted", "follow-up", "converted", "closed"];
